import { Busy } from "../../components/Busy";
import { useSeasonsStore } from "../../store/seasonsStore";
import { Strong, Text } from "../../components/catalyst/text";
import { Button } from "../../components/catalyst/button";
import { useState } from "react";
import { PdfPreviewer } from "../../components/PdfViewer";


export const DocumentForUser = () => {
  const { isBusy, currentSeason } = useSeasonsStore();
  const [currentDoc, setCurrentDoc] = useState<any>(null);
  const docs = currentSeason?.documentsForUsers;

  return (
    <div className="py-5">
      <div className="sm:flex sm:items-center">
        <div className="flex flex-row flex-wrap gap-2 items-center">
          <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
            Documents
          </h1>
          <p className="text-sm text-gray-700 dark:text-gray-200">
            All the documents that are available to read before a
            match starts.
          </p>
        </div>
      </div>
      {!currentSeason && (
        <div className="text-center font-bold bg-gray-100 dark:bg-gray-700 p-4">
          <Text>No current season found. </Text>
        </div>
      )}

      {docs && docs.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          {docs.map((doc) => (
            <div
              key={doc.id}
              className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow bg-slate-100 dark:bg-slate-700"
            >
              <Strong className="font-bold text-lg mb-2">
                {doc.documentTitle}
              </Strong>
              <Text className=" mb-2">
                Version: {doc.documentVersionAndDate}
              </Text>
              <div className="w-full h-40 bg-gray-100 dark:bg-gray-700 rounded-md overflow-hidden">
                <object data={`/api/static/images/${doc.documentUrl}`} type="application/pdf" className="w-full h-full">
                  <embed src={`/api/static/images/${doc.documentUrl}`} type="application/pdf" />
                </object>
              </div>
              <div className="flex justify-end mt-2">
                <Button
                  className="h-6  cursor-pointer"
                  onClick={() => setCurrentDoc(doc)}
                >
                  View
                </Button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        currentSeason && (
          <div className="text-center font-bold bg-gray-100 dark:bg-gray-700 p-4 mt-4">
            <Text>No documents available for the current season.</Text>
          </div>
        )
      )}
      {currentDoc && (
        <PdfPreviewer
          doc={currentDoc}
          closeClicked={() => setCurrentDoc(null)}
        />
      )}

      {isBusy && (
        <Busy busyMessage={"Please wait..."} />
      )}
    </div>
  );
};
